var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47356 34.4983C8.68617 34.4983 8.01587 34.2217 7.46265 33.6685C6.90942 33.1153 6.63281 32.4437 6.63281 31.6538V9.51446C6.63281 8.72455 6.90942 8.05298 7.46265 7.49976C8.01587 6.94653 8.68617 6.66992 9.47356 6.66992H20.5126V9.00159H9.47735C9.34913 9.00159 9.2316 9.05502 9.12477 9.16188C9.01791 9.26871 8.96448 9.38624 8.96448 9.51446V31.6538C8.96448 31.782 9.01791 31.8996 9.12477 32.0064C9.2316 32.1133 9.34913 32.1667 9.47735 32.1667H20.5126V34.4983H9.47356ZM27.4806 27.3925L25.838 25.7403L29.8284 21.75H15.7241V19.4183H29.8284L25.838 15.4279L27.4806 13.7677L34.293 20.5801L27.4806 27.3925Z",
    fill: "#BA3F1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.09854cb77122caa1d6a2e70b560e4f07.svg";
export { ForwardRef as ReactComponent };